// src/components/LoadingScreen.jsx
//
// The screen the app holds while a person's profile and organization load.
// Deliberately unbranded: it shows before we know whose hub this is, so it
// carries no name, no mark and no product colour, only a quiet spinner.

import React from 'react';

const LoadingScreen = ({ label = 'Getting things ready' }) => (
    <div className="flex h-screen items-center justify-center bg-slate-950 relative overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(255,255,255,0.06),transparent_60%)]" aria-hidden="true" />
        <div className="relative flex flex-col items-center gap-5 animate-in fade-in duration-500">
            <div className="relative w-14 h-14" aria-hidden="true">
                <div className="absolute inset-0 rounded-full border-2 border-white/10" />
                <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-white/80 animate-spin" style={{ animationDuration: '1.1s' }} />
                <div className="absolute inset-3 rounded-full bg-white/5 animate-pulse" />
            </div>
            <p className="text-white/70 text-sm font-medium tracking-wide">{label}</p>
        </div>
    </div>
);

export default LoadingScreen;
